'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alifd/next');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Row = _next.Grid.Row,
    Col = _next.Grid.Col;
var AutoColumnsLayout = (_temp = _class = function (_React$Component) {
  _inherits(AutoColumnsLayout, _React$Component);

  function AutoColumnsLayout() {
    _classCallCheck(this, AutoColumnsLayout);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  AutoColumnsLayout.prototype.render = function render() {
    var _props = this.props,
        componentId = _props.componentId,
        _props$layout = _props.layout,
        layout = _props$layout === undefined ? 2 : _props$layout,
        visible = _props.visible,
        children = _props.children,
        disableFieldSelect = _props.disableFieldSelect,
        onBlur = _props.onBlur;


    var className = 'vc-auto-columns-layout';

    var childrenLen = 0; // 组件个数
    if (children && children.length) {
      childrenLen = children.length;
    }

    var wrapChildren = Array(layout).fill(0).map(function () {
      return [];
    }).map(function (arr, i) {
      var _children = [];

      while (i < childrenLen) {
        children[i].props.onBlur = onBlur; // 透传blur事件

        // 透传表单选择模式禁用态，为了做到复杂组件中引入布局组件导致被嵌套的基础组件出现表单选择模式
        children[i].props.disableFieldSelect = disableFieldSelect;
        _children.push(children[i]);
        i += layout;
      }

      arr.push(_react2.default.createElement(
        Col,
        { span: '' + 24 / layout },
        _children
      ));
      return arr;
    });

    return _react2.default.createElement(
      Row,
      { className: className, id: componentId },
      wrapChildren
    );
  };

  return AutoColumnsLayout;
}(_react2.default.Component), _class.propTypes = {
  layout: _propTypes2.default.string || _propTypes2.default.number,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  componentId: _propTypes2.default.string
}, _class.displayName = 'AutoColumnsLayout', _temp);
exports.default = AutoColumnsLayout;
module.exports = exports['default'];